import {RoundedButton} from "../../../../../elements";
import {DefaultTheme as theme} from "../../../../../theme";
import {useCallback, useMemo} from "react";
import {usePromptManagementStore} from "../../hooks";
import {useNavigate} from "react-router-dom";
import {ErrorSeverityEnum} from "../../types";
import IconSelect from "../../../../../elements/v2/Selects/IconSelect/IconSelect";
import {ActionsHeaderWrapper} from "./ActionsHeader.styled";

export const ActionsHeaderDetail = () => {
  const store = usePromptManagementStore();
  const navigate = useNavigate();
  
  const onHandleUpdatePrompt = useCallback(async () => {
    await store.update();
  }, []);
  
  const onHandleCancelPrompt = useCallback(() => {
    store.cancel();
    navigate("/v2/prompt-management-system");
  }, []);

  const actionsOptions = useMemo(() => [
    {
      name: "Delete",
      title: "Delete",
      icon: "cancelSquare",
      onClick: () => {
        store.onConfirmDelete();
      },
    },
    {
      name: "Duplicate",
      title: "Duplicate Conversation",
      icon: "duplicateOutline",
      onClick: () => {
        throw new Error("Not implemented yet");
      },
    },
  ], []);
  
  return (
    <ActionsHeaderWrapper>
      <IconSelect
        placeholder="Actions"
        options={actionsOptions}
      />
      <RoundedButton
        width="99px"
        height="40px"
        color={theme.colors.davysGrey}
        onClick={onHandleCancelPrompt}
        kind={"secondary"}
        outline={true}
      >
        Cancel
      </RoundedButton>
      <RoundedButton
        width="99px"
        height="40px"
        color={theme.colors.activeBlue}
        onClick={onHandleUpdatePrompt}
      >
        Update
      </RoundedButton>
    </ActionsHeaderWrapper>
  );  
};
